class CollectionGridSelector extends HTMLInputElement {
  connectedCallback() {
    this.addEventListener('change', (evt) => {
      const newGridSize = returnSize(parseInt(evt.target.value));
      document.getElementById('ProductGridContainer').classList.add('loading');
      updateGridSizing(this, newGridSize);
    });
  }

  getSections() {
    return [{
      section: document.querySelector('.product-grid').dataset.id
    }];
  }
}

function updateGridSizing(selector, newSize) {
  const url = new URL(window.location);
  const sections = selector.getSections();

  if (newSize === '') {
    url.searchParams.delete('view');
  } else {
    url.searchParams.set('view', newSize);
  }
  window.history.pushState({}, '', url);
  url.searchParams.set('section_id', sections[0].section);

  fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;

      document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    })
    .then(() => {
      document.getElementById('ProductGridContainer').classList.remove('loading');
    });
}

function returnSize(value) {
  let size;
  switch (value) {
    case 1:
      size = 'view-2';
      break;
    case 2:
      size = '';
      break;
    case 3:
      size = 'view-6';
      break;
  }
  return size;
}

customElements.define('grid-sizer', CollectionGridSelector, {
  extends: 'input',
});